import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl, ValidationErrors, FormControl } from '@angular/forms';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProductService } from '../_services/product.service';
import { Product } from '../_models/Product';
import { Organization } from '../_models/Organization';
import { OrganizationService } from '../_services/organization.service';
import { forkJoin } from 'rxjs';
import { UserService } from '../_services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  templateUrl: './client-type-create-modal.component.html',
  styleUrls: ['./client-type-create-modal.component.css']
})
export class ClientTypeCreateModalComponent implements OnInit {

  public loading = false;
  public products: Product[] = [];
  public organizations: Organization[] = [];
  public selectedOrganizationId: number;
  public selectedOrganizationIds: number[] = [];
  public form: FormGroup;

  public clientType;
  clientTypeId = -1;

  constructor(
    private bsModalRef: BsModalRef,
    private productService: ProductService,
    private organizationService: OrganizationService,
    private userService: UserService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService) { }


  close() {
    this.bsModalRef.hide();
  }

  saveAndClose() {
    if (!this.form.valid) {
      return;
    }
    this.loading = true;
    this.spinner.show();

    const newClientType = {
      name: this.form.controls.clientTypeName.value,
      code: this.form.controls.clientTypeCode.value,
      organizations: this.selectedOrganizationIds,
      products: this.products,
      clientTypeId: this.clientTypeId
    };

    this.userService.createClientType(newClientType).subscribe(() => {
      this.loading = false;
      this.spinner.hide();
      this.bsModalRef.hide();
    });
  }

  toggleOrganizationSelect(organizationId: number) {
    const index = this.selectedOrganizationIds.indexOf(organizationId);
    if (this.selectedOrganizationIds.indexOf(organizationId) > -1) {
      this.selectedOrganizationIds.splice(index, 1);
    } else {
      this.selectedOrganizationIds.push(organizationId);
    }
  }

  private initForm(clientType: any, products: any[]) {
    this.form = this.fb.group({
      clientTypeName: ['', Validators.required],
      clientTypeCode: ['', Validators.required],
      products: this.fb.array(products.map(p => this.fb.group({
          price : [p.price, Validators.required],
          name: p.name
        }
      ), Validators.required))
    });
  }

  ngOnInit() {
    this.loading = true;
    this.spinner.show();

    const organizationObs = this.organizationService.getAllOrganizations();
    const productObs = this.productService.getAll();
    const clientTypeObs = this.userService.getClientType(this.clientTypeId);

    forkJoin([organizationObs, productObs, clientTypeObs]).subscribe(data => {
      this.organizations = data[0];
      this.products = data[1];
      this.clientType = data[2];

      this.products.forEach(item => {
        item.price = 0;
      });
      this.initForm(this.clientType, this.products);

      if (this.clientType != null) {
        this.products = this.clientType.products;
        this.form.controls.clientTypeName.patchValue(this.clientType.name);
        this.form.controls.clientTypeCode.patchValue(this.clientType.code);
        this.clientType.organizations.forEach(element => {
          this.selectedOrganizationIds.push(element.organizationId);
        });
      }
      this.loading = false;
      this.spinner.hide();
    });
  }
}

